export const data_setting_menu = [
   {
   id: 1,
   title: 'Общие',
   url: '/settings/generally',
   group_name: 'generally_setting',
   permission_key: 'setting_generally'
},{
   id: 2,
   title: 'Сотрудники',
   url: '/settings/employees',
   group_name: 'generally_setting',
   permission_key: 'setting_employees'
},{
   id: 3,
   title: 'Локации',
   url: '/settings/branches',
   group_name: 'generally_setting',
   permission_key: 'setting_branch'
},{
   id: 4,
   title: 'Склады',
   url: '/settings/warehouse',
   group_name: 'generally_setting',
   permission_key: 'setting_warehouse'
},{
   id: 5,
   title: 'Статусы',
   url: '/settings/status',
   group_name: 'app_setting',
   permission_key: 'setting_status'
},{
   id: 6,
   title: 'Теги',
   url: '/settings/tags',
   group_name: 'app_setting',
   permission_key: 'setting_tags'
},{
   id: 7,
   title: 'Оповещения',
   url: '/settings/alerts',
   group_name: 'app_setting',
   permission_key: 'setting_alert'
},{
   id: 8,
   title: 'Услуги',
   url: '/settings/services_pricelist',
   group_name: 'app_setting',
   permission_key: 'setting_service'
// },{
//    id: 9,
//    title: 'Справочники',
//    url: '/settings/books',
//    group_name: 'app_setting',
//    permission_key: 'setting_book'
// },{
//    id: 10,
//    title: 'Шаблоны документов',
//    url: '/settings/document-templates',
//    group_name: 'app_setting',
//    permission_key: 'setting_template'
// },{
//    id: 11,
//    title: 'Цены и скидки',
//    url: '/settings/prices',
//    group_name: 'app_setting',
//    permission_key: 'setting_price'
// },{
//    id: 12,
//    title: 'Маркетинг',
//    url: '/settings/marketing',
//    group_name: 'app_setting',
//    permission_key: 'setting_marketing'
}
]